module.exports = __webpack_public_path__ + "static/media/sample-cdr.631a0e56.xlsx";